import React, { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import styles from '../Expense.module.scss';

export default function ExpenseBillDateModal({
  bill,
  saving,
  error,
  onSave,
  onClose,
}) {
  const [date, setDate] = useState(new Date(bill.createdAt));
  return (
    <div className={styles.modal} role="dialog" aria-label="Sửa ngày chi">
      <div className={styles.overlay} onClick={onClose} />
      <form
        className={styles.formUpdate}
        onSubmit={async (e) => {
          e.preventDefault();
          if (date && (await onSave({ id: bill.id, date: date.toISOString() })))
            onClose();
        }}
      >
        {error && <p role="alert">{error}</p>}
        <div className={styles.dateWrapper}>
          <label htmlFor="expense-date" className={styles.datePickerLabel}>
            Ngày chi
          </label>
          <ReactDatePicker
            id="expense-date"
            className={styles.datePicker}
            selected={date}
            onChange={setDate}
            dateFormat="dd/MM/yyyy"
            required
          />
        </div>
        <button className={styles.btn} disabled={saving || !date}>
          Cập nhật
        </button>
        <button className={styles.btn} type="button" onClick={onClose}>
          Hủy
        </button>
      </form>
    </div>
  );
}
